import(/* webpackMode: "eager" */ "/app/src/app/(landing)/ecosystem/[id]/page.tsx");
